import React from "react";

import StoreCardSettingsPage from "../../../pages/sales/store/StoreCardSettingsPage";

const SalesStoreManagePage = React.lazy(() => import("../../../pages/sales/store/StorePage"));
const StoreCreatePage = React.lazy(() => import("../../../pages/sales/store/StoreCreatePage"));
const StoreImportItemsPage = React.lazy(() => import("../../../pages/sales/store/StoreImportItemsPage"));
const DevicePage = React.lazy(() => import("../../../pages/sales/store/DevicePage"));
// const DeviceDetailPage = React.lazy(() => import("../../../pages/sales/store/DeviceDetailPage"));
// const StoreSearchTestToolPage = React.lazy(() => import("../../../pages/sales/store/StoreSearchTestToolPage"));
const StoreKioskInfoPage = React.lazy(() => import("../../../pages/sales/store/StoreKioskInfoPage"));
// const StoreCardSettingsPage = React.lazy(() => import("../../../pages/sales/store/StoreCardSettingsPage"));
const StoreLinePaySettingsPage = React.lazy(() => import("../../../pages/sales/store/StoreLinePaySettingsPage"));
const StoreTableManagePage = React.lazy(() => import("../../../pages/sales/store/StoreTableManagePage"));
const StoreOrderListPage = React.lazy(() => import("../../../pages/sales/store/StoreOrderListPage"));
const StoreConfigSettingPage = React.lazy(() => import("../../../pages/sales/store/StoreConfigSettingPage"));
const StoreRoutes = [
    {
        path: "",
        children: [
            { path: "", element: <SalesStoreManagePage /> },
            {
                path: "create",
                children: [
                    {
                        path: "",
                        element: <StoreCreatePage />,
                    },
                ],
            },
            {
                path: ":storeId",
                children: [
                    // {
                    //     path: "edit",
                    //     element: <StoreCreatePage />,
                    // },
                    {
                        path: "import-items",
                        element: <StoreImportItemsPage />,
                    },
                    {
                        path: "card-settings",
                        element: <StoreCardSettingsPage />,
                    },
                   
                    {
                        path: "linepay-settings",
                        element: <StoreLinePaySettingsPage />,
                    },
                    {
                        path: "device-management",
                        children: [
                            {
                                path: "",
                                element: <DevicePage />,
                            },
                            {
                                path: ":deviceId",
                                element: <StoreKioskInfoPage />,
                            },
                        ],
                    },
                    {
                        path: "table-management",
                        element: <StoreTableManagePage />,
                    },
                    {
                        path: "orders",
                        element: <StoreOrderListPage />,
                    },
                    // {
                    //     path: "search-test-tool",
                    //     element: <StoreSearchTestToolPage />,
                    // },

                    {
                        path: "config",
                        element: <StoreConfigSettingPage />,
                    },
                ],
            },
        ],
    },
];

export default StoreRoutes;
